var _script, _mask, _g, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs, _script2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSeth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 480,
    height: 480,
    viewBox: "0 0 480 480",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: ""
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0-113404",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 480,
    height: 480
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 240,
    r: 240,
    fill: "url(#paint0_linear-610315)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0-113404)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 240,
    r: 240,
    fill: "#31D8A4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 240,
    r: 208,
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 240,
    r: 184,
    fill: "#0E052F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240 424C341.62 424 424 341.62 424 240C424 138.38 341.62 56 240 56C138.38 56 56 138.38 56 240C56 341.62 138.38 424 240 424Z",
    fill: "#627EEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M245.728 102V204.005L331.944 242.53L245.728 102Z",
    fill: "white",
    fillOpacity: 0.602
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M245.727 102L159.5 242.53L245.727 204.005V102Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M245.728 308.631V377.942L332.001 258.583L245.728 308.631Z",
    fill: "white",
    fillOpacity: 0.602
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M245.727 377.942V308.62L159.5 258.583L245.727 377.942Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M245.728 292.59L331.944 242.53L245.728 204.028V292.59Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M159.5 242.53L245.727 292.59V204.028L159.5 242.53Z",
    fill: "white",
    fillOpacity: 0.602
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear-610315",
    x1: 240,
    y1: 0,
    x2: 240,
    y2: 701.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08021E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F0777"
  })))), _script2 || (_script2 = /*#__PURE__*/React.createElement("script", {
    xmlns: ""
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeth);
export default __webpack_public_path__ + "static/media/seth.471360030d7b1f7b5dbeee24e1ad0a03.svg";
export { ForwardRef as ReactComponent };